import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Tooltip } from '@mui/material';
import React from 'react';
import { translate } from '../../../../common/intl';

const PrimarySupplier = () => {
  return (
    <Box display="flex" justifyContent="center">
      <Tooltip
        title={translate('form.builder.supplier.contacts.grid.heading.primary.contacts')}
        placement="top"
        arrow
      >
        <FontAwesomeIcon icon={solid('star')} />
      </Tooltip>
    </Box>
  );
};

export default PrimarySupplier;
